import React from "react";
import { Link } from "react-router-dom";
import { EventsCarousel } from "../elements/EventsCarousel";

export const IsaacEventsCarousel = () => {
  return (
    <div className="isaac-events-carousel">
      <EventsCarousel />
      <div className="center-container pb-5">
        <Link className="browse-events" to="/events">
          Browse all events
        </Link>
      </div>
    </div>
  );
};
